<template>
  <div class="col-xl-7 col-lg-8">
    <div class="card card-body shadow text-left">
      <h1 class="h5 text-center">Prijava v račun</h1>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">

        <form @submit.prevent="handleSubmit(login)" novalidate>

          <div class="form-group">
            <ValidationProvider name="email" vid="email" rules="required|email" v-slot="{ errors }">
              <input type="email" class="form-control" v-model="host.email" name="email" placeholder="Email naslov" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider name="password" vid="password" rules="required" v-slot="{ errors }">
              <input type="password" class="form-control" v-model="host.password" name="password" placeholder="Geslo" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
            <div class="text-right text-small mt-2">
              <router-link to="/password/email">Pozabljeno geslo?</router-link>
            </div>
          </div>
          <!--<div class="form-group">
            <div class="custom-control custom-checkbox text-small">
              <input type="checkbox" class="custom-control-input" id="sign-in-remember">
              <label class="custom-control-label" for="sign-in-remember">Remember me next time</label>
            </div>
          </div>-->
          <button class="btn btn-primary btn-block" type="submit">Prijava</button>
        </form>
      </ValidationObserver>
    </div>
    <div class="text-center text-small mt-3">
      Še nimate računa?
      <router-link to="/register/email">Ustvarite ga tukaj</router-link>.
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data: () => ({
    host: {
      email: '',
      password: ''
    }
  }),
  methods: {
    login: function(){
      this.$parent.login(this.host)
      .then(response => {
        if(response.error){
          console.log(response.error.messages);
          this.$refs.form.setErrors(response.error.messages);
        }else{
          return location.href="/login";
          this.$router.push('/login');
        }
      });
    },
  }
}
</script>
